import React from 'react';
import ErrorBoundary from 'components/features/error-boundary/error-boundary';

function Container({ children }) {
  return (
    <ErrorBoundary>
      <div className="d-flex flex-column justify-content-between" style={{ minHeight: '100vh' }}>
        {children}
      </div>
    </ErrorBoundary>
  );
}

export default Container;
